export const getters = {
    loadingFirmas: state => state.loadingFirmas,
    errorFirmas: state => state.errorFirmas,
    firmas: state => state.firmas
}